  //model ---->  BidPipeSaddlesBus
  //saveparam   -----> BidPipeSaddlesSaveParam

import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { BaseBus } from "./BaseBus";

  export class BidPipeSaddlesBus extends BaseBus{

    constructor(busObj: BidPipeSaddlesBus) {
        super(busObj);

    }
    CID(): any {
        return this.saddleSizeId;
    }
    setId(id: any) {
        this.saddleSizeId = id;
    }
    setParentId(id: any) {
        this.bidSheetDetailId = id;
    }
    initialize(data: BidPipeSaddlesBus) {
        super.initialize(data);
        this.insertDt = CommonFunctions.getDate(data.insertDt);
        this.updateDt = CommonFunctions.getDate(data.updateDt);
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: BidPipeSaddlesBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();

        if (this.hasId) {
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);

    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        this.updateDt = date;
        if (this.hasId) {
            this.updateUserId = userId;

        }
        else {
            this.insertDt = date;
            this.insertUserId = userId;
             this.updateUserId = userId;
        }
    }

    bidPipeSaddleQtyId: string;  // chenged to saddleSizeId
    bidSheetDetailId: string;
    saddleSizeId: string;
    qty:number;
    unitCost:number;
    totalCost:number;
    insertDt:Date;
    insertUserId: string;
    updateDt:Date;
    updateUserId: string;
    saddleSizeValue: string;
    saddleSizeDescr: string;
    inventoryId: string;
    inventoryNumber: string;
    inventoryDesc: string;

}

export class LLPipeSizeBus {
    constructor(data: LLPipeSizeBus = null) {
        if (data != null) {
            Object.assign(this, data);
        }
    }
    public combinedVal: string;
    public decimalVal: number;
    public description:string;
    public insertDt: string;
    public insertUserId: string;
    public thicknessId?: string;
    public sizeId?: string;
    public updateDt: string;
    public updateUserId: string;
    public value: string;
}